import { Link } from "react-router-dom";
import { ThumbsUp } from "@phosphor-icons/react";
import { imgUrl } from "@/lib/api";

/**
 * Ultra-compact thumbnail used inside the auto-scrolling Just Listed and
 * Fan Favorites strips. Square image + a single meta row (price · likes).
 * The full title is exposed via a native tooltip on hover so we can keep the
 * visual density tight.
 *
 * Not interactive on likes here — those strips are for browsing, not liking.
 * Users can still like via the full ListingCard on the grid or the detail page.
 */
export default function ThumbListingCard({ listing }) {
  const img = imgUrl(listing.front_image, { w: 200 });
  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`thumb-card-${listing.id}`}
      title={listing.title}
      className="group h57-surface h57-surface-hover flex flex-col transition-transform duration-150 hover:-translate-y-0.5"
    >
      <div className="aspect-square bg-[#0A0A0A] relative overflow-hidden">
        {img ? (
          <img src={img} alt={listing.title} className="w-full h-full object-contain" loading="lazy" decoding="async" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-mono text-[8px] text-zinc-700 tracking-widest">NO IMG</div>
        )}
      </div>
      <div className="px-1.5 py-1 flex items-center justify-between gap-1">
        <span className="font-display font-black text-[11px] text-[#FF5F1F] tabular-nums leading-none">
          ${Number(listing.price).toFixed(0)}
        </span>
        {listing.likes_count > 0 && (
          <span className="inline-flex items-center gap-0.5 font-mono text-[9px] text-zinc-400 leading-none">
            <ThumbsUp size={9} weight="fill" className="text-[#FF5F1F]" />
            <span className="tabular-nums">{listing.likes_count}</span>
          </span>
        )}
      </div>
    </Link>
  );
}
